// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-button.is-plain{--el-button-active-text-color:var(--el-color-primary);--el-button-active-border-color:var(--el-color-primary)}.el-button--primary.is-plain{--el-button-border-color:var(--el-color-primary-light-3)}.el-link.el-link--primary:hover{color:var(--el-color-primary-light-3)}.tip-dialog .el-dialog__header{padding:1.6rem 2rem;border-bottom:.1rem solid #ddd}.tip-dialog .el-dialog__footer{padding:0 2rem 3rem}", ""]);
// Exports
module.exports = exports;
